import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import { DataProvider } from './Context/CacheContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isGlobalApp = window?.location?.pathname === '/app';
root.render(
  <BrowserRouter>
    <App isGlobalApp={isGlobalApp} />
  </BrowserRouter>
);
